module.exports = __webpack_public_path__ + "img/leftthigh-endomorph-male.5212df1e.svg";